$(function () {
    if ($('form.js-form').length) {

        var formsHandler = {
            freezForm: function ($form_) {
                $form_.find(".js-preloader").show();
                $form_.find("input, textarea, select").attr("disabled", true);
                $form_.find("button[type=submit]").addClass("is-loading");
            },
            unFreezForm: function ($form_) {
                $form_.find(".js-preloader").hide();
                $form_.find("input, textarea, select").removeAttr("disabled", true);
                $form_.find("button[type=submit]").removeClass("is-loading");
            },
            callbacks: {
                onErrors: [],
                onSuccess: [],
            },
            init: function () {
                var self = this;

                $('form.js-form').on("submit", function (e) {
                    e.preventDefault();

                    var $form = $(this),
                        formName = $form.attr("name"),
                        formData = new FormData();

                    $form.find("input,select,textarea").each(function () {
                        if ($(this).attr('type') == "checkbox") {
                            if ($(this).is(':checked')) {
                                formData.append(this.name, $(this).val());
                            }
                        } else {
                            formData.append(this.name, $(this).val());
                        }
                    });


                    self.freezForm($form);
                    $form.find(".is-danger").removeClass("is-danger");
                    $("#js-form-" + formName + "-error").empty();


                    var url = $form.attr("action") + "/" + formName;


                    $.ajax({
                        type: 'POST',
                        dataType: 'json',
                        url: url,
                        data: formData,
                        contentType: false,
                        processData: false,
                        success: function (response) {
                            self.unFreezForm($form);

                            if (self.callbacks.onSuccess[formName]) {
                                self.callbacks.onSuccess[formName](response);
                            } else {
                                $form.hide();

                                $("#js-form-" + formName + "-success").html(response.message);
                                $("#js-form-" + formName + "-success__wrap").show();

                                $("body, html").animate({
                                    scrollTop: $("#js-form-" + formName + "-success__wrap").offset().top - 50
                                }, 100);
                            }
                        },
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                            self.unFreezForm($form);

                            for (let field in XMLHttpRequest.responseJSON.errors) {
                                $form
                                    .find("[name=" + field + "]")
                                    .addClass("is-danger")
                                    .focus();
                                
                                console.log(field);
                            }

                            if (self.callbacks.onErrors[formName]) {
                                self.callbacks.onErrors[formName](XMLHttpRequest, textStatus, errorThrown);
                            }
                        }
                    });
                });
            },
        };


        formsHandler.init();
    }


    $(".js-show-modal").on("click", function (e) {
        e.preventDefault();
        $(".js-modal").addClass("is-active");
    });

    $(".js-close-modal").on("click", function (e) {
        e.preventDefault();
        $(".js-modal").removeClass("is-active");
    });
});



// WEBPACK FOOTER //
// ./js/parts/forms.js